import React from 'react'
import Menu from "./sub_components/Menu.js"

import extra from "../images/extra_page.png"

function Extra() {
  return (
    <div id="E404_container">
      <Menu></Menu>
      <span style={{display:"block", width:"fit-content", margin:"5vh auto", fontSize:"32px"}}>Seems that we are out of extra content, for now!</span>
      <img id="extra" src={extra} alt='extra newspaper container' style={{display:"block", width:"80%", margin:"auto"}}></img>
    </div>
  )
}

export default Extra